import Cart from "../features/cart/Cart";

export default function CartPage() {
  return <Cart></Cart>;
}
